import React, {useEffect, useState} from 'react';
import {Spinner} from '@tkww/orion-web-ds-feedback';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import style from './style.scss';

const FullScreenSpinner = () => {
  const {height} = useWindowDimensions();
  const [minHeight, setMinHeight] = useState(null);
  const [offsetTop, setOffsetTop] = useState(null);

  useEffect(() => {
    if (typeof offsetTop === 'number') {
      setMinHeight(height - offsetTop);
    }
  }, [height, offsetTop]);

  return (
    <div
      className={style['spinner-container']}
      data-testid="full-screen-spinner"
      ref={newRef => {
        if (newRef) {
          setOffsetTop(newRef.offsetTop);
        }
      }}
      style={{minHeight}}>
      <Spinner />
    </div>
  );
};

export default FullScreenSpinner;
